<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div :class="['wrapper', { 'with-history': showHistory }]">
          <div class="title">
            <div class="title__text title">
              {{ fiatToCrypto ? "Buy" : "Sell" }} Cryptocurrency
            </div>
            <div
              v-if="$parent.isAuth"
              @click="showHistory = !showHistory"
              class="title__history"
            >
              <template v-if="!showHistory">
                <img src="../images/history.svg" alt="" />
                <span class="desc">History</span>
              </template>
              <span v-else class="desc">Close history</span>
            </div>
          </div>
          <div :class="['content', { 'show-history': showHistory }]">
            <div class="content__left">
              <div class="card-list exchange">
                <div class="card-list__item give">
                  <div class="item__header">
                    <div class="title small">Give</div>
                    <!--                  <div v-if="$parent.wallets && $parent.wallets.length" class="exchange">-->
                    <!--                    <ExchangeButton @click="toggleFiatToCrypto" />-->
                    <!--                  </div>-->
                  </div>
                  <FiatSection
                    v-if="fiatToCrypto"
                    v-bind:give-amount.sync="giveAmount"
                    :change-take-amount="changeTakeAmount"
                    :default-take-currency="defaultTakeCurrency"
                    v-bind:give-currency.sync="giveCurrency"
                    v-bind:payment-method.sync="paymentMethod"
                    :currencies="filteredCurrencies"
                    :toggle-fiat-to-crypto="toggleFiatToCrypto"
                  />
                  <CryptoSection
                    v-else
                    v-bind:take-currency.sync="takeCurrency"
                    :give-currency="giveCurrency"
                    v-bind:take-amount.sync="takeAmount"
                    :rates="rates"
                    :filtered-rates-eur="filteredRatesEur"
                    :filtered-rates-usd="filteredRatesUsd"
                    :toggle-fiat-to-crypto="toggleFiatToCrypto"
                    :change-give-amount="changeGiveAmount"
                    v-bind:payment-method.sync="paymentMethod"
                  />

                  <!--                <div class="input-container">-->
                  <!--                  <input type="number" v-model="giveAmount" @input="changeTakeAmount(giveAmount)"/>-->
                  <!--                  <div v-if="giveCurrency.title == 'Euro'" class="desc">EUR</div>-->
                  <!--                  <div v-else-if="giveCurrency.title == 'US dollar'" class="desc">USD</div>-->
                  <!--                  <div v-else class="desc">{{giveCurrency.title}}</div>-->
                  <!--                </div>-->
                  <!--                <div class="radio-buttons">-->
                  <!--                  <div class="desc">Choose a currency:</div>-->
                  <!--                  <div class="list" v-if="$parent.currencies">-->
                  <!--                    <div class="item" v-for="item in $parent.currencies" :key="item.title">-->
                  <!--                      <label>-->
                  <!--                        <input type="radio" v-model="giveCurrency" :value="item" @input="defaultTakeCurrency"/>-->
                  <!--                        <div v-if="item.title == 'Euro'" class="desc">EUR</div>-->
                  <!--                        <div v-else-if="item.title == 'US dollar'" class="desc">USD</div>-->
                  <!--                        <div v-else class="desc">{{item.title}}</div>-->
                  <!--                      </label>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </div>-->
                  <!--                <div class="radio-list">-->
                  <!--                  <div class="list">-->
                  <!--                    <div class="item">-->
                  <!--                      <label>-->
                  <!--                        <input type="radio" v-model="paymentMethod" name="paymentMethod" value="card"/>-->
                  <!--                        <div class="text">-->
                  <!--                          <div class="desc">Visa/MasterCard</div>-->
                  <!--                        </div>-->
                  <!--                      </label>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </div>-->
                </div>
                <div @click="toggleFiatToCrypto" class="change-btn">
                  <div class="change-btn__wrapper">
                    <img src="../images/exchange-arrows.svg" alt="" />
                  </div>
                </div>
                <div class="card-list__item take">
                  <div class="top">
                    <div class="title small">Take</div>
                    <div
                      v-if="
                        takeCurrency &&
                        giveCurrency &&
                        takeCurrency.crypto_currency &&
                        takeCurrency.price &&
                        giveCurrency.code
                      "
                      class="desc"
                    >
                      1 {{ takeCurrency.crypto_currency.toUpperCase() }} =
                      {{ takeCurrency.price }} {{ giveCurrency.code }}
                    </div>
                  </div>
                  <CryptoSection
                    v-if="fiatToCrypto"
                    v-bind:take-currency.sync="takeCurrency"
                    :give-currency="giveCurrency"
                    v-bind:take-amount.sync="takeAmount"
                    :rates="rates"
                    :filtered-rates-eur="filteredRatesEur"
                    :filtered-rates-usd="filteredRatesUsd"
                    :change-give-amount="changeGiveAmount"
                    v-bind:payment-method.sync="paymentMethod"
                  />
                  <FiatSection
                    v-else
                    v-bind:give-amount.sync="giveAmount"
                    :change-take-amount="changeTakeAmount"
                    :default-take-currency="defaultTakeCurrency"
                    v-bind:give-currency.sync="giveCurrency"
                    v-bind:payment-method.sync="paymentMethod"
                    :currencies="filteredCurrencies"
                  />
                  <!--                <div class="input-container">-->
                  <!--                  <input type="number" v-model="takeAmount" @input="changeGiveAmount(takeAmount);"/>-->
                  <!--                  <div class="desc">{{takeCurrency.crypto_currency}}</div>-->
                  <!--                </div>-->
                  <!--                <div class="radio-list">-->
                  <!--                  <div class="list" v-if="$parent.rates && giveCurrency.title == 'Euro'">-->
                  <!--                    <div class="item" v-for="item in filteredRatesEur" :key="item.id">-->
                  <!--                      <label>-->
                  <!--                        <input type="radio" v-model="takeCurrency" :value="item" />-->
                  <!--                        <div class="text">-->
                  <!--                          <div class="desc">{{item.crypto_currency}}</div>-->
                  <!--                          <div class="desc">{{item.price}} : 1</div>-->
                  <!--                        </div>-->
                  <!--                      </label>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="list" v-if="$parent.rates && giveCurrency.title == 'US dollar'">-->
                  <!--                    <div class="item" v-for="item in filteredRatesUsd" :key="item.id">-->
                  <!--                      <label>-->
                  <!--                        <input type="radio" v-model="takeCurrency" :value="item" />-->
                  <!--                        <div class="text">-->
                  <!--                          <div class="desc">{{item.crypto_currency}}</div>-->
                  <!--                          <div class="desc">{{item.price}} : 1</div>-->
                  <!--                        </div>-->
                  <!--                      </label>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </div>-->
                </div>
                <!--              <div class="card-list__item transactions">-->
                <!--                <div class="title small">Transactions</div>-->
                <!--                <div class="desc" v-if="!$parent.orderHistory.length">No orders yet</div>-->
                <!--                <div class="list" v-if="$parent.orderHistory.length">-->
                <!--                  <div class="item" v-for="(item, index) in $parent.orderHistory" :key="index">-->
                <!--                    <div class="desc align-left">#{{ item.id }}</div>-->
                <!--                    <div class="desc align-left"></div>-->
                <!--                    <div class="desc align-left">{{ item.created_at | moment('DD MMMM YYYY, HH:mm') }}</div>-->
                <!--                    <div class="desc align-left">{{ item.dest_amount }} {{ item.dest_asset.toUpperCase() }}</div>-->
                <!--                    <div class="desc align-left">{{ item.status }}</div>-->
                <!--                    <div class="desc align-left">- {{ item.source_asset }} {{ item.amount }}</div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--              </div>-->
              </div>
              <div class="card-list__item buy-item">
                <div class="desc">
                  Buy cryptocurrencies with a profitable exchange rate
                </div>
                <button
                  :disabled="!this.giveAmount || !this.takeAmount"
                  :class="[
                    'button',
                    { disabled: !this.giveAmount || !this.takeAmount },
                  ]"
                  @click="submit"
                >
                  Confirm
                </button>
                <!--              <button class="button" v-if="!$parent.isAuth" @click="$parent.openSignInModal">Confirm</button>-->
              </div>
            </div>
            <div v-if="showHistory" class="content__right">
              <div class="card-list">
                <div class="card-list__item">
                  <div class="item__header">
                    <div class="title small">Transactions</div>
                  </div>

                  <TransactionsTable :currencies="currencies" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
// import ExchangeButton from "@/components/ExchangeButton.vue";
import FiatSection from "@/components/FiatSection.vue";
import CryptoSection from "@/components/CryptoSection.vue";
import { mapGetters } from "vuex";
import TransactionsTable from "@/components/TransactionsTable.vue";

export default {
  name: "BuyCrypto",
  props: ["currencies", "crypto", "rates"],
  components: {
    TransactionsTable,
    CryptoSection,
    FiatSection,
    // ExchangeButton
  },
  data: function () {
    return {
      giveCurrency: {},
      takeCurrency: {},
      giveAmount: 100,
      takeAmount: 0,
      paymentMethod: "card",
      fiatToCrypto: true,
      showHistory: false,
    };
  },
  watch: {
    currencies: {
      immediate: true,
      handler() {
        console.log("currencies trigger");

        if (Object.values(this.filteredCurrencies)[0]) {
          this.giveCurrency = Object.values(this.filteredCurrencies)[0];
        }
      },
    },
    takeCurrency: {
      immediate: true,
      handler() {
        console.log("triggered take currency");
        this.changeTakeAmount(this.giveAmount);
      },
    },
    rates: {
      immediate: true,
      handler(newValue) {
        if (newValue[0]) {
          this.takeCurrency = newValue[0];
        }
      },
    },
  },
  computed: {
    filteredRatesEur() {
      let rates = this.$parent.rates.filter((item) => item.currency === "EUR");

      if (!this.fiatToCrypto) {
        const parent = this.$parent;
        const wallets =
          parent.wallets &&
          parent.wallets.map((currency) => currency.toUpperCase());
        rates = rates.filter(
          (item) =>
            wallets && wallets.includes(item.crypto_currency.toUpperCase())
        );
      }

      return rates;
    },
    filteredRatesUsd() {
      let rates = this.$parent.rates.filter((item) => item.currency === "USD");

      if (!this.fiatToCrypto) {
        const parent = this.$parent;
        const wallets =
          parent.wallets &&
          parent.wallets.map((currency) => currency.toUpperCase());
        rates = rates.filter(
          (item) =>
            wallets && wallets.includes(item.crypto_currency.toUpperCase())
        );
      }

      return rates;
    },
    filteredCurrencies() {
      if (this.fiatToCrypto) {
        return Object.fromEntries(
          Object.entries(this.$parent.currencies).filter(
            ([, data]) => data.sale
          )
        );
      } else {
        return Object.fromEntries(
          Object.entries(this.$parent.currencies).filter(([, data]) => data.buy)
        );
      }
    },
    ...mapGetters("user", ["isVerified", "verificationSubmitted"]),
  },
  methods: {
    changeTakeAmount(newValue) {
      if (this.takeCurrency.price) {
        this.takeAmount = newValue / this.takeCurrency.price;
      } else {
        this.takeAmount = 0;
      }
    },
    changeGiveAmount(newValue) {
      if (this.takeCurrency.price) {
        this.giveAmount = this.takeCurrency.price * newValue;
      } else {
        this.giveAmount = 0;
      }
    },
    defaultTakeCurrency() {
      console.log("defaultTakeCurrency");
      let rates = null;

      if (this.giveCurrency.code == "EUR") {
        rates = this.filteredRatesEur;
      } else if (this.giveCurrency.code == "USD") {
        rates = this.filteredRatesUsd;
      }

      if (rates && rates.length > 0) {
        console.log("takeCurrency", this.takeCurrency);

        if (
          this.takeCurrency &&
          rates.find(
            ({ crypto_currency }) =>
              crypto_currency === this.takeCurrency.crypto_currency
          )
        ) {
          this.takeCurrency = rates.find(
            ({ crypto_currency }) =>
              crypto_currency === this.takeCurrency.crypto_currency
          );
        } else {
          this.takeCurrency = rates[0];
        }
      } else {
        console.log("unset currency");
        this.takeCurrency = null;
      }
    },
    submit() {
      const fiatAmount = this.giveAmount;

      // if (!this.isVerified) {
      //   this.$toast(`Account verification required`, {type: 'error'});
      //   return;
      // }

      if (!this.isVerified) {
        if (this.verificationSubmitted) {
          this.$toast("Your verification is in progress. Please wait.", {
            type: "info",
          });
        } else {
          this.$router.push({ name: "Profile" });
          this.$toast("Verification required.", { type: "success" });
        }

        return;
      }

      if (
        this.fiatToCrypto &&
        this.$parent.minOrderPriceFiatToCrypto &&
        fiatAmount < this.$parent.minOrderPriceFiatToCrypto
      ) {
        this.$toast(
          `Min order price is ${this.$parent.minOrderPriceFiatToCrypto} EUR.`,
          { type: "error" }
        );
        return;
      } else if (
        !this.fiatToCrypto &&
        this.$parent.minOrderPriceCryptoToFiat &&
        fiatAmount < this.$parent.minOrderPriceCryptoToFiat
      ) {
        this.$toast(
          `Min order price is ${this.$parent.minOrderPriceCryptoToFiat} EUR.`,
          { type: "error" }
        );
        return;
      }

      console.log(
        this.giveAmount,
        this.takeAmount,
        this.takeCurrency,
        this.giveCurrency,
        this.fiatToCrypto
      );

      this.$emit(
        "setCheckoutData",
        this.giveAmount,
        this.takeAmount,
        this.takeCurrency,
        this.giveCurrency,
        this.paymentMethod,
        this.fiatToCrypto,
        new Date()
      );

      if (this.fiatToCrypto) {
        this.$router.push({ name: "CheckoutBuy" });
      } else {
        this.$router.push({ name: "CheckoutSell" });
      }
    },
    toggleFiatToCrypto() {
      this.fiatToCrypto = !this.fiatToCrypto;
      this.paymentMethod = this.fiatToCrypto ? "card" : "crypto";
      let currencies = Object.entries(this.filteredCurrencies);

      if (
        !currencies.some(([, data]) => data.title === this.giveCurrency.title)
      ) {
        this.giveCurrency = currencies[0][1];
        this.defaultTakeCurrency();
      }

      if (!this.fiatToCrypto) {
        if (this.giveCurrency.title === "Euro") {
          if (this.filteredRatesEur && this.filteredRatesEur.length) {
            this.takeCurrency = this.filteredRatesEur[0];
          }
        } else {
          if (this.filteredRatesUsd && this.filteredRatesUsd.length) {
            this.takeCurrency = this.filteredRatesUsd[0];
          }
        }
      }
    },
  },
  mounted: function () {
    if (this.$parent.giveAmount) {
      this.giveAmount = this.$parent.giveAmount;
      this.takeAmount = this.$parent.takeAmount;
      this.takeCurrency = this.$parent.takeCurrency;
      this.giveCurrency = Object.values(this.filteredCurrencies)[0];
    }
  },
};
</script>
